import { defineRouting } from "next-intl/routing";

export const locales = ["ar", "fr", "en", "es"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "ar";

export const rtlLocales: ReadonlySet<Locale> = new Set(["ar"]);

export function isRtl(locale: string): boolean {
  return rtlLocales.has(locale as Locale);
}

export const localeNames: Record<Locale, string> = {
  ar: "العربية (الدارجة)",
  fr: "Français",
  en: "English",
  es: "Español",
};

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: "always",
});
